<div class="legal-page">
  <div class="legal-inner">
    <header class="legal-head">
      <h1>Cookie Policy</h1>
      <p class="legal-updated">Ultimo aggiornamento: ottobre 2026</p>
    </header>

    <section class="legal-panel">
      <h2>1. Premessa</h2>
      <p>
        Questa Cookie Policy spiega come il sito dell’Archivio della Misericordia
        di Borgo San Lorenzo utilizza cookie e tecnologie simili di
        memorizzazione locale. Per l’informativa completa sul trattamento dei
        dati personali si rinvia alla
        <a routerLink="/privacy">Informativa sulla privacy</a>.
      </p>
      <p>
        Per i cookie e le memorizzazioni relative alla sezione pagamenti online
        si veda la
        <a routerLink="/pagamenti/cookie">Cookie Policy della sezione pagamenti</a>.
      </p>
    </section>

    <section class="legal-panel">
      <h2>2. Cosa sono i cookie e le memorizzazioni locali</h2>
      <p>
        I cookie sono piccoli file di testo che un sito può salvare sul
        dispositivo dell’utente. Tecnologie simili (ad esempio
        <em>localStorage</em>) consentono di conservare informazioni necessarie
        al funzionamento del servizio direttamente nel browser.
      </p>
    </section>

    <section class="legal-panel">
      <h2>3. Cookie e memorizzazioni utilizzate su questo sito</h2>
      <p>
        Il sito utilizza esclusivamente strumenti di natura tecnica, necessari
        al funzionamento e alla sicurezza del servizio. Non sono utilizzati
        cookie di profilazione o di marketing di terze parti.
      </p>

      <h3>Strumenti tecnici</h3>
      <ul>
        <li>
          memorizzazione locale necessaria a mantenere lo stato di accesso
          dell’utente alle aree riservate, per la durata della sessione o fino
          al logout;
        </li>
        <li>
          memorizzazione della presa visione del banner informativo sui cookie,
          per non ripresentarlo a ogni visita;
        </li>
        <li>
          eventuali cookie tecnici generati dal browser o dall’infrastruttura
          di erogazione del sito, strettamente funzionali alla navigazione e
          alla sicurezza.
        </li>
      </ul>
      <p>
        Questi strumenti non richiedono il consenso preventivo, fermo restando
        il diritto dell’utente di essere informato e di gestire le impostazioni
        del proprio browser.
      </p>
    </section>

    <section class="legal-panel">
      <h2>4. Gestione delle preferenze</h2>
      <p>
        L’utente può cancellare o bloccare cookie e dati di memorizzazione
        locale dalle impostazioni del browser. La disabilitazione degli
        strumenti tecnici può compromettere l’accesso alle aree riservate o
        alcune funzioni del sito.
      </p>
      <p>
        Il banner informativo presente sul sito consente di prendere visione di
        questa policy e di chiudere l’avviso; la scelta viene ricordata in modo
        tecnico sul dispositivo.
      </p>
    </section>

    <section class="legal-panel">
      <h2>5. Titolare e contatti</h2>
      <p>
        Titolare del trattamento: Confraternita di Misericordia di Borgo San
        Lorenzo, Via Giotto, 34 — 50032 Borgo San Lorenzo (FI),
        P. IVA 01343220487.
      </p>
      <p>
        Contatti:
        <a href="mailto:home@misericordia.net">home&#64;misericordia.net</a>,
        PEC
        <a href="mailto:misericordiabsl@legalmail.it">misericordiabsl&#64;legalmail.it</a>,
        tel. <a href="tel:0558494118">055 8494118</a>.
      </p>
    </section>

    <section class="legal-panel">
      <h2>6. Aggiornamenti</h2>
      <p>
        Questa Cookie Policy può essere aggiornata in caso di modifiche ai
        servizi o alla normativa. La versione corrente è sempre disponibile su
        questa pagina.
      </p>
    </section>
  </div>
</div>
